import React from 'react';
import { formatInTimeZone } from 'date-fns-tz';

import { mapUserLocaleToShorthand } from 'i18n/mapUserLocaleToShorthand';
import { Icon, IconName, IconSize } from '@unmind/design-system';
import { P } from './styles';

interface ITimeZoneProps {
  tz: string;
  date: Date;
}

const TimeZone = ({ tz, date }: ITimeZoneProps) => {
  if (!tz) {
    return null;
  }

  const locale = mapUserLocaleToShorthand();
  const numericTz = formatInTimeZone(date, tz, 'OOOO', { locale });
  const longTz = formatInTimeZone(date, tz, 'zzzz', { locale });

  return (
    <P data-testid="timezone">
      <Icon
        iconName={IconName.Globe}
        size={IconSize.Medium}
        className="globe"
      />
      <span className="timezone">
        ({numericTz}) {longTz}
      </span>
    </P>
  );
};

export default TimeZone;
